import { render, staticRenderFns } from "./CustomJump.vue?vue&type=template&id=5cf88729&scoped=true"
import script from "./CustomJump.vue?vue&type=script&lang=js"
export * from "./CustomJump.vue?vue&type=script&lang=js"
import style0 from "./CustomJump.vue?vue&type=style&index=0&id=5cf88729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf88729",
  null
  
)

export default component.exports